import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

const CustomModal = ({
  title,
  openModal,
  closeModal,
  content,
  actionTitle,
  actionTitle2,
  actionColor,
  actionColor2,
  setConfirmProp,
  setConfirmProp2,
  isHideCancelButton,
}) => {
  const handleConfirmProp = () => {
    setConfirmProp(true);
    closeModal();
  };

  const handleConfirmProp2 = () => {
    setConfirmProp2(true);
    closeModal();
  };

  return (
    <Dialog
      open={openModal}
      onClose={closeModal}
      aria-labelledby="alert-dialog"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          width: { xs: "80vw", md: "30vw" },
          backgroundColor: "#1a1a1a",
          border: "1px solid #2a2a2a",
          borderRadius: "16px",
          color: "#fff",
        },
      }}
    >
      <DialogTitle id="alert-dialog-title" sx={{ color: "#fff", fontWeight: 800, fontSize: "16px" }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" sx={{ color: "#888", fontSize: "14px" }}>
          <p>
            {content?.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        {!isHideCancelButton && (
          <Button sx={{ color: "#666", textTransform: "none", fontWeight: 600 }} onClick={closeModal}>
            Cancel
          </Button>
        )}
        <Button
          sx={{ color: actionColor, fontWeight: 700, textTransform: "none" }}
          autoFocus
          onClick={handleConfirmProp}
        >
          {actionTitle}
        </Button>
        {actionTitle2 && (
          <Button
            sx={{ color: actionColor2, fontWeight: 700, textTransform: "none" }}
            autoFocus
            onClick={handleConfirmProp2}
          >
            {actionTitle2}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default CustomModal;
